export { IconButton, type IconButtonProps } from './styled/icon-button';
